<template>
    <div class="container container-fluid">
        <h1 class="page-heading mb-0">Membership Rate Comparison</h1>

        <aha-component title="">
            <!-- postTableContent rich text content removed from the tableData object and passed in to this slot to resolve IE11 issues with handleing spaces in the rich text content. -->
            <membership-rate-comparison :table-data="demoData">
                <template slot="postTableContent">
                    <div class="flex-table__content-group">
                        <div 
                            class="row">
                            <div class="col-12">
                                <h4 class="rate-comparison__disclaimer-title">Title here is optional</h4>
                            </div>
                        </div>

                        <div 
                            class="row">
                            <div class="col-12 rate-comparison__disclaimer-content">
                                <p>*Verification of Student/Trainee status is required. Please see "Membership Discounts" below for details.<br/><strong>Gold Package</strong> includes online access to Stroke OnDemand™ – slides with synchronized audio from any computer, tablet or smartphone. (Hard Drive purchase available for additional $60)</p>
                            </div>
                        </div>
                    </div>
                </template>
            </membership-rate-comparison>
        </aha-component>

    </div>
</template>

<script>
    export default {
        data() {
            return {
                demoData: {
                    active: false, // needs to be false by default
                    tableName: {
                        preTitle: 'MEMBERS',
                        title: 'General Membership'
                    },
                    rateText: [
                        {
                            title: 'Early Rate',
                            date: 'Oct. 9 - Dec. 31',
                        },
                        {
                            title: 'Advanced Rate',
                            date: 'Jan. 1 - Jan. 28',
                        },
                        {
                            title: 'Standard Rate',
                            date: 'Jan. 29 - Feb. 19',
                        }
                    ],
                    rowData: [
                        {
                            active: false,
                            rowTitle: 'Premium Professional Member',
                            rowDescription: 'Stroke in the real world: A star is Born: Thrombolysis &amp; Thrombectomy',
                            rates: [
                                {
                                    normal: '$500',
                                    gold: '$850'
                                },
                                {
                                    normal: '$600',
                                    gold: '$950'
                                },
                                {
                                    normal: '$700',
                                    gold: '$1,050'
                                }
                            ]
                        },
                        {
                            active: false,
                            rowTitle: 'Premium Professional Plus Member',
                            rates: [
                                {
                                     normal: '$400',
                                    gold: '$750'
                                },
                                {
                                    normal: '$500',
                                    gold: '$850'
                                },
                                {
                                    normal: '$600',
                                    gold: '$950'
                                }
                            ]
                        },
                        {
                            active: false,
                            rowTitle: 'General Professional Member',
                            rates: [
                                {
                                    normal: '$900',
                                    gold: '$1,400'
                                },
                                {
                                    normal: '$1,000',
                                    gold: '$1,500'
                                },
                                {
                                    normal: '$1,200',
                                    gold: '$1,700'
                                }
                            ]
                        },
                        {
                            active: false,
                            rowTitle: 'Premium Emeritus Member',
                            rates: [
                                {
                                    normal: '$75',
                                    gold: '$375'
                                },
                                {
                                    normal: '$1750',
                                    gold: '$475'
                                },
                                {
                                    normal: '$275',
                                    gold: '$575'
                                }
                            ]
                        },
                        {
                            active: false,
                            rowTitle: 'Early Career Member',
                            rates: [
                                {
                                    normal: '$300',
                                    gold: '$600'
                                },
                                {
                                    normal: '$400',
                                    gold: '$700'
                                },
                                {
                                    normal: '$500',
                                    gold: '$800'
                                }
                            ]
                        },
                        {
                            active: false,
                            rowTitle: 'Student/Trainee Member*',
                            rates: [
                                {
                                    normal: '$200',
                                    gold: '$500'
                                },
                                {
                                    normal: '$300',
                                    gold: '$600'
                                },
                                {
                                    normal: '$400',
                                    gold: '$700'
                                }
                            ]
                        },
                        {
                            active: false,
                            rowTitle: 'Professional Associate Member',
                            rates: [
                                {
                                    normal: '$900',
                                    gold: '$1,400'
                                },
                                {
                                    normal: '$1,000',
                                    gold: '$1,500'
                                },
                                {
                                    normal: '$1,200',
                                    gold: '$1,700'
                                }
                            ]
                        }
                    ],
                },
                demoDataWithoutGoldPricing: {
                    active: false, // needs to be false by default
                    tableName: {
                        preTitle: 'MEMBERS',
                        title: 'General Membership (no gold)'
                    },
                    rateText: [
                        {
                            title: 'Early Rate'
                        },
                        {
                            title: 'Advanced Rate'
                        },
                        {
                            title: 'Standard Rate'
                        }
                    ],
                    rowData: [
                        {
                            active: false,
                            rowTitle: 'Premium Professional Member',
                            rowDescription: 'Stroke in the real world: A star is Born: Thrombolysis & Thrombectomy',
                            rates: [
                                {
                                    normal: '$500'
                                },
                                {
                                    normal: '$600'
                                },
                                {
                                    normal: '$700'
                                }
                            ]
                        },
                        {
                            active: false,
                            rowTitle: 'Premium Professional Plus Member',
                            rates: [
                                {
                                    normal: '$400'
                                },
                                {
                                    normal: '$500'
                                },
                                {
                                    normal: '$600'
                                }
                            ]
                        },
                        {
                            active: false,
                            rowTitle: 'General Professional Member',
                            rates: [
                                {
                                    normal: '$900'
                                },
                                {
                                    normal: '$1,000'
                                },
                                {
                                    normal: '$1,200'
                                }
                            ]
                        },
                        {
                            active: false,
                            rowTitle: 'Premium Emeritus Member',
                            rates: [
                                {
                                    normal: '$75'
                                },
                                {
                                    normal: '$1750'
                                },
                                {
                                    normal: '$275'
                                }
                            ]
                        },
                        {
                            active: false,
                            rowTitle: 'Early Career Member',
                            rates: [
                                {
                                    normal: '$300'
                                },
                                {
                                    normal: '$400'
                                },
                                {
                                    normal: '$500'
                                }
                            ]
                        },
                        {
                            active: false,
                            rowTitle: 'Student/Trainee Member*',
                            rates: [
                                {
                                    normal: '$200'
                                },
                                {
                                    normal: '$300'
                                },
                                {
                                    normal: '$400'
                                }
                            ]
                        },
                        {
                            active: false,
                            rowTitle: 'Professional Associate Member',
                            rates: [
                                {
                                    normal: '$900'                                },
                                {
                                    normal: '$1,000'                                },
                                {
                                    normal: '$1,200'                                }
                            ]
                        }
                    ],
                }
            }
        }
    }
</script>




// WEBPACK FOOTER //
// demo/pages/components/phd-membership-rate-comparison.vue